(ns io.daskul.tutorial.webapp.views.invoice-edit
  "Custom invoice edit details card.

   Customer name/email are set at creation via resolve-customer-snapshot.
   Edit page shows them as regular editable fields."
  (:require
   [clojure.string :as str]
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.ui.icons :as icons]
   [io.daskul.webapp.widgets.form.field :as ff]))

;; ============================================================================
;; Details Card
;; ============================================================================

(defui details-card
  "Custom invoice edit form card."
  [{:keys [agg-key config form-data set-field! submit! saving? error
           fields loading? read-only? delete-enabled? open-delete-modal!
           handle-cancel schema]}]
  (let [state (get form-data :state)]
    ($ ui/card {:shadow "sm" :padding "lg" :radius "md" :withBorder true}
      ;; Read-only notice
      (when read-only?
        ($ ui/info-alert {:mb "md"}
          (str "This " (str/lower-case (:label-singular config))
               " is " state " and cannot be edited.")))

      (when-let [form-error (ff/form-level-error-message error fields)]
        ($ ui/error-alert {:mb "md"} form-error))

      (cond
        loading?
        ($ ui/centered-loader)

        (not schema)
        ($ ui/warning-alert {:title "Loading schema..."}
          "Fetching form configuration...")

        :else
        ($ :form {:onSubmit submit!}
          ($ ui/stack {:gap "md"}
            (for [field fields]
              (let [field-key (:name field)]
                ($ ff/form-field
                  {:key (name field-key)
                   :agg-key agg-key
                   :field field
                   :value (get form-data field-key)
                   :on-change #(set-field! field-key %)
                   :disabled (or read-only? (:readonly field))
                   :form-data form-data})))

            ;; Buttons - hidden when read-only
            (when-not read-only?
              ($ ui/group {:justify "space-between" :mt "md"}
                (if delete-enabled?
                  ($ ui/destructive-button
                    {:variant "subtle"
                     :leftSection ($ icons/icon-trash {:size 16})
                     :onClick open-delete-modal!}
                    "Delete")
                  ($ :div))
                ($ ui/group {:gap "sm"}
                  ($ ui/button
                    {:variant "subtle" :color "gray"
                     :onClick handle-cancel}
                    "Cancel")
                  ($ ui/button
                    {:type "submit"
                     :loading saving?}
                    "Save"))))))))))
